import { AGENT_FACTORY_URL_HOME, AGENT_FACTORY_URL_CREATE } from '@/config/urls/agentFactoryUrls';

/**
 * Hook to open the agent factory
 *
 * @returns {{
 *  openAgentsFactory: (page: 'create' | 'home') => void,
 * }}
 */

function useAgentsFactory() {
  const openAgentsFactory = (page) => {
    const url = page === 'create' ? AGENT_FACTORY_URL_CREATE : AGENT_FACTORY_URL_HOME;

    window.open(url, '_self');
  };

  return {
    openAgentsFactory,
  };
}

export default useAgentsFactory;
